module.exports = __webpack_public_path__ + "static/media/sipnalogo.97f24133.png";